import gql from "graphql-tag"
import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"

const query = gql`
  query GetStockById($stockId: String!) {
    stock(stockId: $stockId) {
      code
      createdAt
      createdBy {
        firstname
      }
      expiry
      pin
      poNumber
      product {
        name
        supplier
      }
      status
      type
      updatedAt
      usage
      uuid
      updatedBy {
        firstname
      }
    }
  }
`

export const stockByIdKey = getQueryNames(query)[0]

export default query
